const state = {
  cooperationMenu: [],
  code: 0,
  type: 0,
  privateGroup: 0,
  publicGroup: 0,
  cooperationHiddenMenu: []
};
const actions = {};
const mutations = {
  setMenuData(state, payload) {
    state.cooperationMenu = payload.data;
    state.privateGroup = payload.privateGroup;
    state.publicGroup = payload.publicGroup;
  },
  setMenuType(state, payload) {
    state.type = payload;
  },
  setHiddenMenuData(state, payload) {
    state.cooperationHiddenMenu = payload.data;
  }
};
const getters = {};

export default { state, actions, mutations, getters, namespaced: true };



// WEBPACK FOOTER //
// ./src/js/store/modules/menu.js